/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import {
  Header,
  Footer,
  HeaderParagraph,
  ContainerTitle,
  ContainerSubTitle,
  Icon,
  Container,
  Button,
  BodyWrapper,
  MobileFooter
} from '../components'

import callico from '../static/seo/callico.png'
import envelope from '../static/seo/envelope.png'
import icon from '../static/seo/icon.png'

const TableStyleCss = styled.div`
  .callBtnWrapper {
    display: inline-block;
    background: #2ca24b;
    height: 50px;
    line-height: 50px;
    padding: 7px 30px 7px 80px;
    border-radius: 50px;
    position: fixed;
    bottom: 20px;
    left: 20px;
  }

  .callBtnWrapper a {
    text-decoration: none;
    color: #fff;
    display: block;
  }

  .callBtnWrapper a span:before {
    content: '';
    width: 22px;
    height: 22px;
    display: inline-block;
    position: absolute;
    top: 1px;
    left: 1px;
    padding: 20px;
    border-radius: 50px;
    margin-right: 10px;
    margin-bottom: -5px;
    background: #39cc79 url(${callico}) no-repeat 20px 20px;
  }

  .mailfix {
    display: inline-block;
    background: #2ca24b;
    height: 50px;
    line-height: 50px;
    padding: 7px 80px 7px 30px;
    border-radius: 50px;
    position: fixed;
    bottom: 20px;
    right: 20px;
  }

  .mailfix a {
    text-decoration: none;
    color: #fff;
    display: block;
  }

  .mailfix a span:before {
    content: '';
    width: 22px;
    height: 22px;
    display: inline-block;
    position: absolute;
    top: 1px;
    right: -8px;
    padding: 20px;
    border-radius: 50px;
    margin-right: 10px;
    margin-bottom: -5px;
    background: #39cc79 url(${envelope}) no-repeat 17px 17px;
  }

  .wrap_table_hover {
    border: 0px !important;
    margin-top: 60px;
  }

  .set-scroll-add {
    margin-top: 6%;
  }

  .padding-row-table-set {
    padding-top: 6%;
  }
  .set-table-social-plan .wrap_table thead tr th div strong {
    font-size: 18px;
    text-align: center;
    color: #fff;
    padding: 15px 0;
    background: #000;
    position: absolute;
    bottom: -27px !important;
    width: 100%;
    border-radius: 10px 10px 0 0;
    left: 0;
  }

  .pricing-inner {
    margin-top: 8%;
  }

  .wrap_table thead tr th:first-child {
    font-size: 18px;
    padding: 0px 2%;
    text-align: right;
    font-weight: normal;
    color: #8d8c8c;
    font-family: Arial, Helvetica, sans-serif;
  }

  .wrap_table thead tr th div {
    display: inline-block;
    height: 100%;
    width: 100%;
    position: relative;
    padding-top: 10px;
  }

  .wrap_table thead tr th div strong {
    font-size: 18px;
    text-align: center;
    color: #fff;
    padding: 15px 0;
    background: #000;
    position: absolute;
    bottom: -18px;
    width: 100%;
    border-radius: 10px 10px 0 0;
    left: 0;
  }

  .wrap_table thead tr th div strong:after {
    border-top: 10px solid #000;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    content: '';
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }

  .wrap_table thead tr th div span {
    font-size: 45px;
    color: #353535;
    font-family: 'Conv_AGENCYB';
  }

  .wrap_table thead tr th div span sup {
    font-size: 24px;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
  }

  .wrap_table thead tr th div span b {
    font-size: 20px;
    font-style: normal;
    font-weight: normal;
    font-family: Arial, Helvetica, sans-serif;
  }

  .wrap_table thead tr th div i {
    display: block;
    background: rgba(0, 0, 0, 0.5);
    font-style: normal;
    padding: 5px;
    font-size: 16px;
    color: #fff;
    text-align: center;
  }

  .wrap_table thead tr th {
    border-radius: 0px 0px 10px 10px;
    padding-bottom: 10px;
    font-weight: normal;
    width: 10%;
  }

  .tik-mark {
    display: inline-block;
    background: url(${icon}) -8px -8px no-repeat;
    width: 14px;
    height: 14px;
  }

  .cross-mark {
    display: inline-block;
    background: url(${icon}) -26px -8px no-repeat;
    width: 14px;
    height: 14px;
  }

  .wrap_table tr td {
    font-size: 13px;
    font-family: Verdana, Geneva, sans-serif;
    color: #888;
    text-align: center;
    padding: 8px 36px;
    line-height: 19px;
    box-shadow: inset 0 2px 5px rgba(231, 231, 231, 0.4);
  }

  .wrap_table tbody tr:first-child td {
    height: 50px;
  }

  .wrap_table tr td:not(:first-child),
  .wrap_table tr th:not(:first-child) {
    border-left: solid 1px #fff;
  }

  .wrap_table tr td:first-child,
  .wrap_table tbody tr th:first-child {
    text-align: left;
    padding: 15px;
  }

  .wrap_table tbody tr th {
    font-size: 14px;
    font-family: Verdana, Geneva, sans-serif;
    text-align: center;
    color: #fff;
    font-weight: normal;
    background: #2ca24c !important;
  }

  .wrap_table tr:nth-child(2n + 1) td,
  .wrap_table tbody tr:nth-child(2n + 1) th {
    background: #fbfbfb;
  }

  .wrap_table tr:nth-child(2n + 2) td,
  .wrap_table tbody tr:nth-child(2n + 2) th {
    background: #f6f6f6;
  }

  .wrap_table tr:nth-child(2n + 2) td:first-child,
  .wrap_table tbody tr:nth-child(2n + 2) th:first-child {
    background-color: #fd3e3e;
    background-image: -webkit-linear-gradient(left, #f7f7f7, #ececec);
    background-image: -moz-linear-gradient(left, #f7f7f7, #ececec);
    background-image: -o-linear-gradient(left, #f7f7f7, #ececec);
    background-image: linear-gradient(to right, #f7f7f7, #ececec);
  }

  .wrap_table tbody tr:first-child th:first-child {
    background: #2ca24c !important;
    background-image: none !important;
  }

  .tablefootcont {
    float: right;
    width: 100%;
    background: #7a7a7a;
    font-size: 18px;
    color: #fff;
    padding: 10px;
    text-align: center;
  }

  .blueandredhead {
    font-size: 40px;
    color: #0086ad;
    text-align: center;
  }

  .blueandredhead span {
    color: #d46565;
    font-size: 48px;
    font-family: 'Conv_AGENCYB';
  }

  .whyebrandzbg.innerpage {
    overflow: hidden;
  }

  .whyebrandzbg.innerpage .timelinewrap li {
    padding: 0.3em;
  }

  .whyebrandzbg.innerpage .timelinewrap li strong {
    font-size: 0.6em;
    margin-bottom: 0.3em;
  }

  .whyebrandzbg.innerpage .timelinewrap li p {
    /*font-size:14px*/
    font-size: 16px;
  }

  .whyebrandzbg.innerpage .timelinewrap li:not(:first-child) {
    margin-top: 4%;
  }

  .whyebrandzbg.innerpage .page_headfff {
    font-size: 0.8em;
    margin: 25px 0;
  }

  .innerpagefoot .sub_head_red {
    font-size: 0.7em;
    margin: 25px 0;
  }

  .innerpagefoot .fotterurlwrap li {
    font-size: 0.4em;
  }

  .innerpagefoot .copyrightfoot {
    position: relative;
  }

  .wrap_table tr td {
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  .wrap_table tr td:nth-child(6n + 2).hover {
    background: #f8fdcf;
  }

  .wrap_table tr td:nth-child(6n + 3).hover {
    background: #fdf0cf;
  }

  .wrap_table tr td:nth-child(6n + 4).hover {
    background: #e1f7ca;
  }

  .wrap_table tr td:nth-child(6n + 5).hover {
    background: #d5f4fb;
  }

  .wrap_table tr td:nth-child(6n + 6).hover {
    background: #fae1fb;
  }

  .wrap_table tr td:nth-child(6n + 7).hover {
    background: #dde1fd;
  }

  .wrap_table thead tr th.hover {
    border-radius: 0;
  }

  .tooltipwrap {
    display: inline-block;
    position: relative;
    cursor: pointer;
  }

  .new-wrp {
    display: inline-block;
    background: #fd3e3e;
    padding: 0 2px;
    color: #fff;
    text-transform: uppercase;
    font-style: normal;
    font-size: 10px;
    font-family: Verdana, Geneva, sans-serif;
  }

  .tooltipwrap i {
    background: none repeat scroll 0 0 #ccc;
    border-radius: 50%;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-style: normal;
    padding: 0px;
    text-align: center;
    width: 17px;
  }

  .tooltipwrap span {
    position: absolute;
    border-radius: 10px;
    top: 200%;
    left: -145px;
    z-index: 1;
    display: block;
    width: 300px;
    height: auto;
    text-align: justify;
    font-size: 11px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    -webkit-transition: all 0.3s ease-in-out;
    visibility: hidden;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    padding: 5px;
    visibility: hidden;
    opacity: 0;
  }

  .tooltipwrap span:after {
    position: absolute;
    top: -7px;
    left: 50%;
    margin-left: -3px;
    width: 0;
    height: 0;
    border-bottom: 7px solid rgba(0, 0, 0, 0.7);
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }

  .tooltipwrap:hover span {
    visibility: visible;
    opacity: 1;
    top: 143%;
  }

  .wrap_table tr td:last-child .tooltipwrap span {
    left: -286px;
  }

  .wrap_table tr td:last-child .tooltipwrap span:after {
    margin-left: -13px;
    left: 100%;
  }

  .wrap_table tbody tr th.allcolpas {
    background: #f6ffa6;
    padding: 15px 10px;
    text-align: center;
    font-size: 14px;
  }

  .tablewrapdiv {
    display: table;
    width: 90%;
    margin: 0 5%;
  }

  .tablewrapdiv em {
    display: table-cell;
    font-style: normal;
    vertical-align: middle;
    padding: 5px;
  }

  .tablewrapdiv em i {
    width: 100%;
    display: table;
    font-style: normal;
    border: none;
    color: #fff;
    text-align: center;
    padding: 5px;
  }

  .tablewrapdiv em i + i {
    border-top: dashed 1px #fff;
  }

  .designer .wrap_table thead tr th div strong::after {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: none;
    content: '';
    left: 50%;
    margin-left: -10px;
    position: absolute;
    top: 100%;
  }

  .designer .wrap_table thead tr th div strong {
    background: #efab2e none repeat scroll 0 0;
    border-radius: 10px 10px 0 0;
    bottom: 0;
    color: #fff;
    display: block;

    font-size: 18px;
    left: 0;
    padding: 15px 0;
    position: unset;
    width: 100%;
  }

  .designer .tik-mark {
    background: rgba(0, 0, 0, 0) url('../images/tik-mark.png') no-repeat scroll 0 0;
    display: inline-block;
    height: 20px;
    width: 20px;
  }

  .designer .cross-mark {
    background: rgba(0, 0, 0, 0) url('../images/croc-mark.png') no-repeat scroll 0 0;
    display: inline-block;
    height: 20px;
    width: 20px;
  }

  .designer .wrap_table thead tr th:nth-child(3) div strong {
    background: #eb9531 none repeat scroll 0 0;
  }

  .designer .wrap_table thead tr th:nth-child(4) div strong {
    background: #e0792f none repeat scroll 0 0;
  }

  .designer .wrap_table thead tr th div span {
    background: #e4e4e4 none repeat scroll 0 0;
    color: #353535;
    display: block;
    font-family: arial;
    font-size: 19px;
    margin: 0;
    padding: 12px 5px;
    line-height: 25px;
    float: left;
    width: 100%;
  }

  .designer .wrap_table thead tr th div span abbr {
    float: left;
    font-size: 21px;
    margin-right: 6px;
    left: 0;
  }

  .designer .wrap_table thead tr th {
    border-radius: 0 0 10px 10px;
    font-weight: normal;
    padding-bottom: 0;
    width: 13%;
  }

  .designer .wrap_table thead tr th div span b {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
  }

  .designer .tooltipwrap span {
    background: rgba(0, 0, 0, 0.7) none repeat scroll 0 0;
    color: #fff;
    display: block;

    font-size: 12px;
    height: auto;
    left: 0;
    opacity: 0;
    padding: 5px;
    position: absolute;
    text-align: justify;
    top: 200%;
    transition: all 0.3s ease-in-out 0s;
    visibility: hidden;
    width: 300px;
    z-index: 1;
  }

  .designer .tooltipwrap span::after {
    border-bottom: 7px solid rgba(0, 0, 0, 0.7);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    content: '';
    height: 0;
    left: 7%;
    margin-left: -3px;
    position: absolute;
    top: -7px;
    width: 0;
  }

  .designer .tooltipwrap:hover span {
    visibility: visible;
    opacity: 1;
    top: 143%;
  }

  .sl-con {
    min-height: 550px;
    height: 100%;
    position: relative;
  }

  .feature-con,
  .feature-con div {
    transition: 0.5s;
    -moz-transition: 0.5s;
    -ms-transition: 0.5s;
    -o-transition: 0.5s;
    -webkit-transition: 0.5s;
  }

  .banner_index {
    margin-bottom: 20px;
    background: url('../newimages/banner-bg.jpg') no-repeat scroll 0 0 rgba(0, 0, 0, 0);
    background-size: 100% auto;
    margin-top: 63px;
  }

  .leftNav,
  .rightNav {
    height: 50px;
    width: 50px;
    display: block !important;
    position: absolute;
    top: 50%;
    color: #ccc;
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  .leftNav:hover,
  .rightNav:hover {
    background: rgba(0, 0, 0, 1);
    color: #ffffff;
  }

  .leftNav {
    left: 20px;
  }

  .rightNav {
    right: 20px;
  }

  .rightNav:before,
  .leftNav:before {
    font-family: 'FontAwesome';
    display: block;
    font-size: 40px;
    padding: 0 10px;
    text-align: center;
  }

  .leftNav:before {
    content: '\f104';
  }

  .rightNav:before {
    content: '\f105';
  }

  .pr-wrap {
    position: relative;
  }

  .bannerControls {
    margin-top: 6%;
  }

  .parallax_mouseinteraction {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .parallax_mouseinteraction img {
    max-width: none;
    max-height: none;
  }

  .parallax_mouseinteraction_list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: none;
  }

  .parallax_mouseinteraction .contentHolderVisibleWrapper {
    position: absolute;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .parallax_mouseinteraction .contentHolder {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  .parallax_mouseinteraction .contentHolderUnit {
    float: left;
    display: block;
    overflow: hidden;
  }

  .mycanvas {
    display: none;
  }

  .myloader {
    background: url(images-new/loader.gif);
    width: 37px;
    height: 37px;
    position: absolute;
    left: 49%;
    top: 49%;
    z-index: 5;
  }

  .fixedBackground {
    position: absolute;
    z-index: 0;
  }

  .parallax_mouseinteraction.bullets .bannerControls {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
    width: 100%;
  }

  .parallax_mouseinteraction.bullets .bottomNavButtonOFF {
    float: left;
    display: block;
    width: 14px;
    height: 14px;
    margin: 5px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -webkit-border-radius: 50%;
    background: #eee;
    padding-left: 9px;
    cursor: pointer;
  }

  .parallax_mouseinteraction.thumbs .bottomNav {
    position: absolute;
    width: 0px;
    height: 24px;
    bottom: -35px;
    z-index: 3;
    padding-left: 9px;
  }

  .parallax_mouseinteraction.bullets .bottomNav {
    position: absolute;
    bottom: 10px !important;
    width: 77px !important;
    z-index: 5;
  }

  .parallax_mouseinteraction.bullets .bottomNavButtonON {
    background: #ced0d2;
    cursor: pointer;
  }

  .parallax_mouseinteraction.bullets .bottomNavLeft {
    position: absolute;
    width: 0;
    display: none;
    background: #f00;
    height: 24px;
    bottom: 5px;
    z-index: 3;
  }

  .parallax_mouseinteraction.bullets .bottomNavRight {
    position: absolute;
    width: 0;
    display: none;
    height: 24px;
    background: #f00;
    bottom: 5px;
    z-index: 3;
  }

  .parallax_mouseinteraction.bullets .bottomOverThumb {
    position: absolute;
    width: 88px;
    height: 95px;
    bottom: 25px;
    margin-left: -44px;
  }

  .parallax_mouseinteraction.bullets .innerBottomOverThumb {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 4px 0 0 4px;
    overflow: hidden;
  }

  .parallax_mouseinteraction.bullets .playOver {
    position: absolute;
    width: 73px;
    height: 73px;
    display: none;
    z-index: 4;
    cursor: pointer;
  }

  .parallax_mouseinteraction.bullets .playOver:hover {
    display: none;
    z-index: 4;
    cursor: pointer;
  }

  .parallax_mouseinteraction.thumbs .bannerControls {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
    width: 100%;
  }

  .parallax_mouseinteraction.thumbs .bottomOverThumb {
    position: absolute;
    width: 88px;
    height: 95px;
    bottom: 25px;
    margin-left: -44px;
  }

  .parallax_mouseinteraction.thumbs .innerBottomOverThumb {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 4px 0 0 4px;
    overflow: hidden;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolderWrapper {
    position: absolute;
    height: 135px;
    width: 100%;
    overflow: hidden;
    padding: 0;
    z-index: 2;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolderVisibleWrapper {
    position: absolute;
    width: 100%;
    height: 135px;
    overflow: hidden;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolder {
    position: absolute;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolder_ThumbOFF {
    float: left;
    display: block;
    width: 95px;
    height: 65px;
    cursor: pointer;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolder_ThumbOFF img {
    position: relative;
  }

  .parallax_mouseinteraction.thumbs .thumbsHolder_ThumbON img {
    position: relative;
  }

  .parallax_mouseinteraction_texts {
    position: absolute;
    z-index: 2;
    width: 100%;
  }

  .parallax_mouseinteraction_text_line {
    position: absolute;
    display: none;
    width: 100%;
  }

  .textElement11_bullets {
    xwidth: 25%;
    font: bold 32px/38px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement11_bullets a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement11_bullets a:hover {
    text-decoration: underline;
  }

  .textElement12_bullets {
    font: 14px/20px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    width: 23%;
  }

  .textElement12_bullets a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: underline;
  }

  .textElement12_bullets a:hover {
    color: #d7151e;
    text-decoration: underline;
  }

  .textElement30_bullets {
    font: bold 24px/32px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #d51220;
  }

  .textElement31_bullets {
    font: bold 60px/66px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement31_bullets a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement31_bullets a:hover {
    text-decoration: underline;
  }

  .textElement32_bullets {
    font: 14px/21px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
    width: 26%;
  }

  .textElement11_bulletsFW {
    xwidth: 25%;
    font: 50px/21px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
  }

  .textElement11_bulletsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement11_bulletsFW a:hover {
    text-decoration: underline;
  }

  .textElement12_bulletsFW {
    font: 24px/32px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    xwidth: 23%;
  }

  .textElement12_bulletsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: underline;
  }

  .textElement12_bulletsFW a:hover {
    color: #d7151e;
    text-decoration: underline;
  }

  .textElement30_bulletsFW {
    font: bold 28px/38px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #d51220;
  }

  .textElement31_bulletsFW {
    font: bold 77px/64px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement31_bulletsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement31_bulletsFW a:hover {
    text-decoration: underline;
  }

  .textElement32_bulletsFW {
    font: 25px/34px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    width: 33%;
  }

  .wraptable {
    display: table;
  }

  .wraptable span {
    display: table-cell;
    padding-left: 10px;
    vertical-align: middle;
  }

  .bannericonsrl {
    width: 4em;
    height: 4em;
    display: table-cell;
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
  }

  .bannericonsrl.yellow {
    background: #e4ca1a;
  }

  .bannericonsrl.green {
    background: #7fb933;
  }

  .bannericonsrl.blue {
    background: #4199bd;
  }

  .textElement11_thumbs {
    xwidth: 25%;
    font: bold 32px/38px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement11_thumbs a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement11_thumbs a:hover {
    text-decoration: underline;
  }

  .textElement12_thumbs {
    font: 14px/20px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    width: 23%;
  }

  .textElement12_thumbs a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: underline;
  }

  .textElement12_thumbs a:hover {
    color: #d7151e;
    text-decoration: underline;
  }

  .textElement30_thumbs {
    font: bold 24px/32px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #d51220;
  }

  .textElement31_thumbs {
    font: bold 60px/66px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement31_thumbs a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement31_thumbs a:hover {
    text-decoration: underline;
  }

  .textElement32_thumbs {
    font: 14px/21px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
    width: 26%;
  }

  .textElement11_thumbsFW {
    xwidth: 25%;
    font: bold 48px/53px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement11_thumbsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement11_thumbsFW a:hover {
    text-decoration: underline;
  }

  .textElement12_thumbsFW {
    font: 24px/32px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    xwidth: 23%;
  }

  .textElement12_thumbsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: underline;
  }

  .textElement12_thumbsFW a:hover {
    color: #d7151e;
    text-decoration: underline;
  }

  .textElement30_thumbsFW {
    font: bold 28px/38px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #d51220;
  }

  .textElement31_thumbsFW {
    font: bold 77px/84px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement31_thumbsFW a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement31_thumbsFW a:hover {
    text-decoration: underline;
  }

  .textElement32_thumbsFW {
    font: 25px/34px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
    width: 24%;
  }

  .textElement11_sideBar {
    font: bold 32px/38px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement11_sideBar a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement11_sideBar a:hover {
    text-decoration: underline;
  }

  .textElement12_sideBar {
    font: 16px/20px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #d7151e;
  }

  .textElement12_sideBar a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #d7151e;
    text-decoration: underline;
  }

  .textElement12_sideBar a:hover {
    color: #fff;
    text-decoration: underline;
  }

  .textElement20_sideBar {
    font: bold 16px/20px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #d51220;
  }

  .textElement21_sideBar {
    font: bold 32px/30px 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
  }

  .textElement21_sideBar a {
    font: 'CenturyGothicRegular', Verdana, Helvetica, sans-serif;
    color: #fff;
    text-decoration: none;
  }

  .textElement21_sideBar a:hover {
    text-decoration: underline;
  }

  .hideElement {
    display: none;
  }

  /*sliderend*/

  .agreement .heading1 {
    margin-bottom: 10px;
    margin-top: 26px;
  }

  .agreement .free-demo span {
    color: #333;
  }

  .agreement p + p {
    margin-top: 12px;
  }

  .table {
    width: 80%;
    margin: 43px 5%;
  }

  .table li {
    border: 1px solid #d4d4d4;
    padding: 10px;
    margin-bottom: 1px !important;
    padding-left: 10px;
    background: none !important;
    font-size: 17px;
  }

  .table li i {
    margin-right: 15px;
    border-right: 1px solid #ccc;
    padding-right: 15px;
  }

  .agreement {
    width: 100%;
    float: left;
    margin-bottom: 50px;
  }

  div.dataTables_wrapper {
    width: 800px;
    margin: 0 auto;
  }

  /* socila plan table css */

  /* socila plan table css */

  @media only screen and (max-width: 1300px) {
    .wp_plan .pricing-con {
      position: absolute;
      top: 34%;
      width: 100%;
    }
  }

  @media only screen and (max-width: 1100px) {
    .header [class^='grid_'] {
      width: 98% !important;
    }

    .top-menu ul li {
      padding: 0 10px;
    }

    .login-box {
      position: absolute !important;
      top: 0px !important;
      right: 0 !important;
    }

    .header {
      position: static !important;
    }

    .banner-bg,
    .banner_index {
      margin-top: 0px;
    }
  }

  @media only screen and (max-width: 800px) {
    .res768 [class^='grid_'] {
      width: 98% !important;
      margin-bottom: 20px;
    }

    #audit-reports,
    #seo-software,
    #PPC-reporting,
    .feature-content {
      padding-top: 0px;
    }

    .reputation-monitoring {
      position: relative;
      margin-top: 50px;
    }

    .feature-con {
      text-align: center;
    }

    #audit-reports .grid_9 {
      padding-top: 150px;
    }

    #seo-software .grid_11 {
      padding-top: 150px;
    }

    #call-traking #before-3 {
      padding-bottom: 205px;
    }

    .circle-social,
    .circle-seo,
    .circle-ppc {
      top: 50px;
    }

    .moz-line {
      top: 12px;
    }

    #users-and-roles {
      padding-bottom: 90px;
    }

    .innerpage {
      margin-top: 50px;
    }

    .whychose {
      padding: 16px 10px;
      font-size: 16px;
    }

    .plans {
      margin: 10px 0;
    }

    .con-1000 [class^='grid_'] {
      width: 98% !important;
    }

    .newFS .large-btn {
      font-size: 13px;
      padding: 10px;
      margin: 0px;
    }

    .page-banner.wp_plan {
      margin-top: 2px;
      position: relative;
      color: #ffffff;
    }

    h1.page_heading {
      font-family: Verdana;
      font-size: 46px;
    }

    .wp_plan .pribtn {
      font-size: 18px;
      padding: 10px 22px;
    }

    .freedemo-title {
      font-size: 22px;
    }
  }

  @media only screen and (min-width: 640px) {
    .menu-con {
      display: block !important;
    }
  }

  @media only screen and (max-width: 640px) {
    .menu-con li i {
      display: block;
    }

    .top-menu ul li {
      padding: 0 5px;
      border-bottom: 1px solid #ccc;
    }

    .slider-nav,
    .whychose {
      width: 100%;
    }

    .login-box {
      position: static !important;
    }

    .top-menu ul li {
      width: 100%;
      padding: 10px;
    }

    .top-menu ul li:last-child {
      border: none;
    }

    .top-menu,
    .login-box {
      margin-top: 10px;
    }

    .header .menubtn {
      display: block;
    }

    .menu-con {
      display: none;
    }

    .top-menu ul li ul {
      width: 100%;
      margin-top: 10px;
      position: static !important;
      display: none;
    }

    .top-menu ul li:hover ul {
      display: none;
    }

    .whychose br {
      display: none;
    }
  }

  .prd_table td {
    background: #dfdfdf;
    padding: 20px 0px;
    text-align: center;
  }

  .prd_table tr:nth-child(even) td {
    background: #dfdfdf;
  }

  .prd_table tr:nth-child(odd) td {
    background: #f0f0f0;
  }

  .red_smo {
    background: #e5b8b7 !important;
    text-align: center !important;
  }

  .blue_smo {
    background: #b6dde8 !important;
    text-align: center !important;
  }

  .lightblue_smo {
    background: #daeef3 !important;
    text-align: center !important;
  }

  .green_smo {
    background: #eaf1dd !important;
    text-align: center !important;
  }

  @media (max-width: 768px) {
    .wrap_table thead tr th div strong {
      font-size: 12px;
      text-align: center;
      color: #fff;
      padding: 11px 0;
      background: #000;
      position: absolute;
      bottom: -17px;
      width: 100%;
      border-radius: 10px 10px 0 0;
      left: 0;
    }

    .set-table-social-plan .wrap_table thead tr th div strong {
      font-size: 18px;
      text-align: center;
      color: #fff;
      padding: 15px 0;
      background: #000;
      position: absolute;
      bottom: -41px !important;
      width: 100%;
      border-radius: 10px 10px 0 0;
      left: 0;
    }

    .set-paddind-tablee {
      margin-top: 12%;
    }

    .set-scroll-add {
      overflow: scroll;
    }
  }
  .logo {
    text-align: center;
    background: white;
    box-shadow: 1px 2px 3px rgba(25, 25, 25, 0.22);
    padding: 10px;
  }
  .logo img {
    width: 220px;
  }
`

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 20px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
  @media (max-width: 540px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`

const VecterCircle = styled.div`
  width: 520px;
  height: 520px;
  min-width: 520px;
  min-height: 520px;
  border-radius: 50%;
  border: 1px solid #e8e5e5;
  margin: 0 auto;
  position: relative;
  @media (max-width: 768px) {
    transform: scale(0.75);
  }
  @media (max-width: 520px) {
    transform: scale(1);
    width: 320px;
    height: 320px;
    min-width: 320px;
    min-height: 320px;
  }
  @media (max-width: 360px) {
    transform: scale(0.8);
  }
`
const TopDiv = styled.div`
  margin: 0 auto;
  max-width: 2560px;
`
const CircleCenter = styled.div`
  position: absolute;
  width: 100%;
  top: 0px;
  height: 100%;
  display: flex;
  padding-top: 20px;
  align-items: flex-start;
`
const CircleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  width: 100%;
  & > img {
    height: 20px;
  }
  & > h3 {
    font-size: 21px;

    line-height: 1.52;
    text-align: center;
    color: #333333;
    padding: 44px 0 24px;
    @media (max-width: 520px) {
      padding: 20px 0 10px;
    }
  }
  & > p {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
    max-width: 400px;
    word-break: break-word;
    @media (max-width: 520px) {
      max-width: 240px;
      font-size: 14px;
    }
  }
`
const Line = styled.div`
  width: 51px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-bottom: 26px;
`
const CircleWithImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > img:nth-child(1) {
    width: 102px;
    position: relative;
  }
  & > img:nth-child(2) {
    width: 36px;
    position: absolute !important;
    padding: 0 0 10px 0 !important  ;
  }
`
const CareersWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & + img {
      max-width: 100% !important;
      height: 200px !important;
      object-fit: cover !important;
    }
  }
  & > h1 {
    align-self: flex-start;
    text-align: left;
  }
  & > p {
    align-self: flex-start;
    padding: 0;
    text-align: left;
  }
  & + img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
`
const OpeningWrapper = styled.div`
  display: flex;
  padding: 80px 80px;
  margin: 0 auto;
  max-width: 1366px;
  flex-wrap: wrap;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 0 20px;
  }
  @media (max-width: 640px) {
    padding: 0 10px;
  }
`
const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 40%;
  padding: 30px 20px 0 0;
  flex-wrap: wrap;
  & > p:nth-child(1) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 1.6px;
    color: #333333;
    margin-bottom: 0;
    padding-bottom: 4px;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    line-height: 1.21;
    color: #333333;
    margin: 0;
    padding-bottom: 10px;
  }
  & > p:nth-child(3) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
  }
  @media (max-width: 768px) {
    width: 100%;
    flex-basis: 100%;
    padding: 30px 0 30px 0;
    & > p:first-child {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.25;
      letter-spacing: 1.2px;
    }
    & > p:nth-child(3) {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.86;
      letter-spacing: 0.1px;
    }
  }
`
const RightWrapper = styled.div`
  display: flex;
  width: 60%;
  flex-wrap: wrap;
  & > div:first-child {
    margin-right: 30px;
    flex-basis: calc(50% - 30px);
  }
  @media (max-width: 768px) {
    flex-basis: 100%;
    & > div:first-child {
      margin-right: 30px;
      flex-basis: calc(50% - 30px);
    }
    & > div:last-child {
      margin-right: 30px;
      padding: 40px 20px;
      flex-basis: calc(50% - 30px);
    }
  }
  @media (max-width: 520px) {
    & > div:first-child {
      margin-right: 0;
      margin-bottom: 30px;
      flex-basis: calc(100% - 0px);
    }
    & > div:last-child {
      margin-right: 0;
      flex-basis: calc(100% - 0px);
    }
  }
`
const SocialFlexWrapper = styled.div`
  @media (max-width: 768px) {
    max-width: 100%;
    & > p:nth-child(3) {
      width: 100% !important;
    }
  }
  width: calc(50% - 30px);
  padding: 30px;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border: solid 1px rgba(0, 0, 0, 0.1);
  @media (max-width: 840px) {
    width: calc(50% - 20px);
    padding: 20px;
  }
  & > p:nth-child(1) {
    padding: 0px 0 10px;
    font-size: 22px;

    line-height: 1.45;
    color: #333333;
  }
  & > p:nth-child(2) {
    word-break: break-word;
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    padding-bottom: 20px;
    @media (max-width: 840px) {
      width: 100%;
    }
  }
`

const ValueContainer = styled.div`
  margin: 0 auto;
  max-width: 2560px;
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 40px;
  }
`
const PerksWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1366px;
  margin: 0 auto;
  padding: 60px 80px;
  flex-wrap: wrap;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  & > div:first-child {
    flex-basis: 40%;
    & > img {
      width: 100%;
      object-fit: contain;
    }
  }
  @media (max-width: 840px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    & > img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
`
const PerksTextWrapper = styled.div`
  padding-left: 30px;
  flex-basis: 60%;
  & > p:nth-child(1) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 1.6px;
    color: #333333;
  }
  & > p:nth-child(2) {
    font-size: 38px;

    line-height: 1.21;
    color: #333333;
  }
  & > ul {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.1px;
    color: #333333;
    padding: 20px 0 0px 0;
    margin: 0 0 0 20px;
    & > li {
      padding-bottom: 8px;
      position: relative;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px;
    flex-basis: 100%;
    & > p:nth-child(1) {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: 0.1px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
      font-weight: normal;
      line-height: 1.5;
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }
    & > ol {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.57;
      letter-spacing: 0.1px;
      margin: 10px 0;
    }
  }
  @media (max-width: 840px) {
    padding: 40px 0 0 20px;
  }
`

const CoreTeamWrapper = styled.div`
  padding: 80px 0 80px 0;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`

const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 80px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 33.33%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`

const FirstSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto;
  position: relative;
  top: -10px;
  @media (max-width: 520px) {
    max-width: 240px;
  }
`
const SecondSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 620px;
  min-width: 620px;
  left: -50px;
  margin: 0 auto;
  padding: 100px 0;
  position: relative;
  @media (max-width: 520px) {
    max-width: 240px;
    min-width: 360px;
    padding: 50px 0;
    left: -20px;
  }
`
const ThirdSet = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto;
  position: relative;
  bottom: -10px;
  @media (max-width: 520px) {
    max-width: 240px;
    min-width: 240px;
    bottom: -30px;
  }
`
const Placeholder = styled.div`
  font-size: 36px;
  width: 102px;
  height: 102px;
  border-radius: 50%;
  color: ${props => (props.selected ? '#fff' : '#999')};
  background-color: ${props => (props.selected ? '#f0425f' : '#ffffff')};
  box-shadow: ${props =>
    props.selected ? ' 0 8px 16px 0 rgba(240, 66, 95, 0.2)' : ' 0 8px 16px 0 rgba(0, 0, 0, 0.08);'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 520px) {
    height: 60px;
    width: 60px;
    font-size: 28px;
  }
`
const ButtonHolder = styled.div`
  margin-top: 40px;
`

const HrEmail = styled.div`
  padding: 0 0 20px 0;
`

const perksArray = [
  'We give our employees the freedom to choose their work profile and enhance their skill set.',
  'We give our employees ownership and control of their work.',
  'Flexible working hours has been every employees’ desire and we believe in making our employees happy.',
  'We provide our employees half yearly appraisals to keep them updated about their performance and motivate them to work harder.',
  'We believe that employee growth leads to the growth of the organization, therefore we provide our employees all the necessary training.'
]
const content = {
  V: { title: 'Value', dec: 'Always looking for ways to add value to our clients, colleagues and industry.' },
  EEE: { title: 'Efficiency', dec: 'Embracing the latest technology and systems to save more time and money.' },
  C: {
    title: 'Customer Focus',
    dec: 'Customer Satisfaction is a strong contributor to our overall success of the business.'
  },
  T: {
    title: 'Transparency',
    dec: 'Operating with honesty, integrity and transparency. Being direct and upfront in all communication.'
  },
  E: {
    title: 'Enjoyment',
    dec: 'Enjoyment at workplace keeps everyone motivated and brings the best out of everyone.'
  },
  R: { title: 'Respect', dec: 'For our clients, work colleagues, other bookkeepers and the society.' }
}

export class SeoListing extends Component {
  state = {
    selected: 'V'
  }
  componentDidMount() {}
  render() {
    const { selected } = this.state
    return (
      <Fragment>
        <Header />
        <TopDiv>
          <TopWrapper>
            <HeaderParagraph headerColor={'#333333'} headerFontSize={'38px'} header={'Seo '} paragraph={''} />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/seo/analytics-seo.jpg')} alt="About Us" />
          </ImageWrapper>
        </TopDiv>
        <TableStyleCss>
          <OpeningWrapper>
            <table
              width="100%"
              cellSpacing={0}
              cellPadding={0}
              border={0}
              className="wrap_table  wrap_table_hover set-paddind-tablee">
              <thead>
                <tr>
                  <th scope="col" style={{ width: '22%' }} className />
                  <th scope="col">
                    <div>
                      <strong>
                        VALUE
                        <br />
                        $399/M
                      </strong>{' '}
                      {/* <span><sup>$</sup>549<b>/mo</b></span> <i>20 Keywords</i>  */}
                    </div>
                  </th>
                  <th scope="col">
                    <div>
                      <strong>
                        SILVER
                        <br />
                        $599/M
                      </strong>{' '}
                      {/* <span><sup>$</sup>899<b>/mo</b></span> <i>35 Keywords</i> */}
                    </div>
                  </th>
                  <th scope="col">
                    <div>
                      <strong>
                        GOLD
                        <br />
                        $649/M
                      </strong>{' '}
                      {/* <span><sup>$</sup>1349<b>/mo</b></span> <i>50 Keywords</i> */}
                    </div>
                  </th>
                  <th scope="col">
                    <div>
                      <strong>
                        PLATINUM
                        <br />
                        $849/M
                      </strong>
                      {/* <span><sup>$</sup>2199<b>/mo</b></span> <i>80 Keywords</i> */}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Target Keywords </td>
                  <td> 40 </td>
                  <td> 80 </td>
                  <td> 120 </td>
                  <td> 160</td>
                </tr>
                <tr>
                  <th>Conversion Tracking</th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    Call Tracking
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        Call tracking is a great way for you to track success of the campaign. It will include tracking
                        of one Local Number. We will set it up for you. You can view and track all the stats via
                        AgencyPlatform Dashboard. Extra cost will be applicable for additional numbers.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Retargeting Setup
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        Retargeting Setup helps you to reach out to people that have previously been to specific pages
                        on your website. This will help client get better ROI as returning visitors are more likely to
                        sign-up. Client can spend anywhere from $50 to $300 per month on this campaign. We will setup
                        and manage campaign for free, but they will have to pay the ad fees directly to Google. The
                        average cost per click would be anywhere from $ 0.50 to $1 and a retargeting campaign helps
                        dramatically increase ROI.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Web Form Conversion Tracking
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will convert existing forms on your website for use with our system so that you can track and
                        monitor all incoming leads via these forms within our dashboard.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Google Analytics
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will install Google Analytics tracking code on your website along with event tracking, goal
                        setup and more. You can track Analytics data right from the dashboard as well.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    HeatMap <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        We will generate a heatmap of your home page displaying which parts of your page users visit and
                        click frequently. You get to know what's hot and what's not, so you can make changes accordingly
                        to increase conversions.{' '}
                      </span>
                    </span>
                  </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    ScrollMap <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        The scrollmap shows how far down the page people are scrolling and helps determine where
                        visitors abandon the page. Now you'll know exactly where to add elements to hold a visitor's
                        interest longer.{' '}
                      </span>
                    </span>
                  </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Overlay Report <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        With the overlay report, you will be able to see the number of clicks on each element of your
                        web page.{' '}
                      </span>
                    </span>
                  </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Confetti <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        With confetti, you will be able to distinguish all the clicks you get on your site segmented by
                        referral sources, search terms &amp; more.{' '}
                      </span>
                    </span>
                  </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                  <td> Homepage </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    User Testing Video
                    <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        A user testing video with voice over talking about the errors / difficulties encountered while
                        browsing your website from a layman’s perspective.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Advanced Website Usability &amp; Conversion Optimization Report
                    <span className="tooltipwrap">
                      <i>?</i>{' '}
                      <span>
                        {' '}
                        We will do an in-depth usability and conversion analysis of your website and create a report
                        with mockups and highlight suggestions to make the site user as well as conversion friendly to
                        generate more leads.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                </tr>
                <tr>
                  <th>On-Page Optimization</th>
                  <td>
                    <strong> </strong>
                  </td>
                  <td>
                    <strong> </strong>
                  </td>
                  <td>
                    <strong> </strong>
                  </td>
                  <td>
                    <strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Onsite Recommendations &amp; Implementation
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        <ul>
                          <li>Initial SEO analysis</li>
                          <li>Initial competitive analysis</li>
                          <li>Optimization of Titles &amp; Meta Tags Optimization</li>
                          <li>Image, Hyperlink &amp; Header Tag Optimization</li>
                          <li>Robots.txt Optimization</li>
                          <li>HTML Source Code Optimization</li>
                          <li>XML sitemap Creation for Google/Bing</li>
                          <li>Canonicalization / 301 Redirect URLs</li>
                          <li>Google +1 Button</li>
                          <li>Linking to social profiles</li>
                          <li>Google &amp; Bing Webmaster Tool Configuration</li>
                          <li>Google Analytics Setup</li>
                        </ul>
                      </span>
                    </span>
                  </td>
                  <td> Basic </td>
                  <td>Professional</td>
                  <td>Professional</td>
                  <td>Advanced</td>
                </tr>
                <tr>
                  <td>
                    Adding Rich Snippets
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will add rich snippets on your website wherever applicable such as business address, customer
                        reviews, ecommerce products, etc.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Backlink Analysis
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will do an in-depth backlink audit of the website via Google Webmaster Tools and other third
                        party tools and suggest removal / disavowing of bad backlinks to the site.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Onsite Blog Setup
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span> We will setup a SEO friendly blog on your website, if not setup already. </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <th>Inbound Content Marketing </th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    Website Content Writing (250 Words Per Page)
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We write search engine friendly content for the website based on the keywords we have finalized.
                      </span>
                    </span>
                  </td>
                  <td>8</td>
                  <td>12</td>
                  <td>15</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>
                    Blog Writing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will do the research and create a blog post to be added on the internal blog of the website.
                      </span>
                    </span>{' '}
                  </td>
                  <td>6</td>
                  <td>9</td>
                  <td>12</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Blog Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will share the website blog posts to your social channels to get traffic moving in to the
                        website.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Guest Blog Post Writing &amp; Syndication
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will write SEO friendly guest blog posts and syndicate them across relevant blogs.{' '}
                      </span>
                    </span>
                  </td>
                  <td>9</td>
                  <td>12</td>
                  <td>15</td>
                  <td>21</td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Guest Blog Post Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will share the guest blogs on top social networks like Facebook, Twitter and Google Plus to
                        acquire social votes.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Informational Content Writing &amp; Syndication
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will write SEO friendly informational content and syndicate them across relevant domains
                        featuring informational content.{' '}
                      </span>
                    </span>
                  </td>
                  <td>12</td>
                  <td>21</td>
                  <td>36</td>
                  <td>48</td>
                </tr>
                <tr>
                  <td>
                    Informational Content Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will share the informational content on top social networks like Facebook, Twitter and Google
                        Plus to acquire social votes.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Press Release Writing &amp; Distribution
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create Press Releases based on newsworthy information and distribute them across
                        authority PR networks.{' '}
                      </span>
                    </span>
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Press Release Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will share the submitted press releases on top social networks like Facebook, Twitter and
                        Google Plus to acquire social votes.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Infographic Creation &amp; Distribution
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        People love Infographics; and since they are instantly shareable and engaging, search engines
                        love them too. We create high quality infographics for you which will be shared across various
                        channels and draw qualified traffic to your site.
                      </span>
                    </span>
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>2</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Infographic Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will share the submitted infographics on top social networks like Facebook, Twitter and
                        Google Plus to acquire social votes.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Magazine / News Placement <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will be posting a magazine / client interview based on the information provided by you.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Q&amp;A Posting <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span> We will be posting Q&amp;A’s relevant to the your business on high authority sites. </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Premium PR Distribution
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        By submitting to premium sources, your PR will be distributed across top news networks thereby
                        increasing your brand awareness. A link or a citation from such sources will definitely help to
                        boost rankings.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>1</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>
                    Premium Authoritative Directory Submissions
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will be submitting your site to premium authoritative directories like Yahoo, Business, etc.
                        A link from such sources will definitely help to improve your rankings.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <th>Local Search Website Optimization</th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    Google My Business/ Bing, Apple Maps &amp; Facebook Local Listing Optimization
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will be optimizing the client Google My Business / Bing Local listing by verifying the
                        business. If the business is already verified we will further optimize it by updating images,
                        videos, categories and business hours.{' '}
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr />
                <tr>
                  <td>
                    Authority Business Listing (Yelp, Local.com etc) <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will submit your business to high authority local directories and review sites like Yelp,
                        Local.com and others thereby ensuring a strong local presence.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Local Citation Building
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will submit your business to top authority local directories, review sites and social
                        networks to get your business maximum exposure.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    NAP Syndication
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        For a local business, location specific links are of utmost importance. We will be getting links
                        from sources which also allow your Business Name, Address and Phone Number (NAP) to be added to
                        the listing thus increasing credibility of that link.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Review Widget <i className="new-wrp" />{' '}
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will be adding a widget on your website pages which will help you build positive customer
                        reviews.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Coupon Distribution
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        To diversify our link profile, we will even submit any coupons you might have to top coupon
                        sharing sites. This helps to increase your presence apart from getting a link or a citation.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Startup Business Listings
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>We will be creating your business listing at the top startup business directories.</span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <th>Link Strategy</th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    {' '}
                    Website Social Sharing
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        Since social signals are given much prominence of late, social sharing becomes even more
                        important. Sharing content across social networks like facebook, twitter and Google+ helps to
                        increase inbound links and citations due along with improved online visibility/brand awareness.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                  <td>
                    {' '}
                    <span className="tik-mark" />{' '}
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Video Creation
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will create video about client business using stock video footage. Stock footage is an easy
                        and affordable way to include ?motion? in your videos. We buy stock footage based on your video
                        requirement from a company which sells royalty free stock footage. We will submit the video to
                        video submission sites like Youtube, MySpace, Metacafe etc. We will also convert the video into
                        PPT and submit to PPT submission sites like slideshare.net.
                      </span>
                    </span>{' '}
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Video Submission
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will submit videos to top distribution networks such as YouTube, Vimeo, MetaCafe and others.{' '}
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Voiceover Video Creation
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will create video about client business with voiceover. The script will include an
                        introduction to client business and a call to action or an offer. We will use a Male voice {'{'}
                        based out of United States
                        {'}'}
                        for voiceover. We will submit the video to video submission sites like Youtube, MySpace,
                        Metacafe etc.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>
                    Voiceover Video Submission
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will submit voiceover videos to top distribution networks such as YouTube, Vimeo, MetaCafe
                        and others.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Social Profiles{' '}
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will create your business profile across various social channels to generate backlinks and
                        even citations from social profiles.
                      </span>
                    </span>{' '}
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    PPT Creation
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span> We will create Presentations for your business based on videos and infographics. </span>
                    </span>
                  </td>
                  <td>1</td>
                  <td>1</td>
                  <td>1</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>
                    PPT Distribution
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will distribute the Presentations to authority sites like SlideShare, Scribd and others to
                        diversify the backlink profile.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Image Submission
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will submit Images / Graphics from the website to top image sharing websites like Flickr,
                        PhotoBucket and others.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Social Community Setup <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We will create a community profile on important / relevant social networks and share guest
                        posts, videos and other information to attract users.{' '}
                      </span>
                    </span>
                  </td>
                  <td>3</td>
                  <td>3</td>
                  <td>3</td>
                  <td>3</td>
                </tr>
                <tr>
                  <th>Social Media Marketing</th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    Social Reputation Monitoring
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will monitor your business’ or brands online reputation by tracking various sources and
                        displaying them as positive, negative or neutral sentiments within the dashboard.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Access To Premium Apps
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        You will have access to various premium apps to be used with your Facebook Business page to keep
                        the user engaged.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Youtube Channel Setup/ Optimization
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        We setup and optimize a YouTube channel for your business. The main benefit of a YouTube channel
                        is users view the video, comment or potentially share it with their other social media networks
                        thus increasing social signals.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Facebook Cover Image
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create a customized engaging cover image for your businesses’ Facebook page.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Twitter Background Image
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span> We will create a customized background image for your businesses’ Twitter account. </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Twitter Header Image Background
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create a customized engaging header image for your businesses’ Twitter account.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Content For Facebook Info &amp; Twitter Bio
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create catchy and promotional content to be used with your business’ Facebook and
                        Twitter accounts.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Content Posting on Twitter &amp; Facebook
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create viral and engaging posts to be shared via your business’ Twitter &amp; Facebook
                        accounts.{' '}
                      </span>
                    </span>
                  </td>
                  <td>12</td>
                  <td>18</td>
                  <td>24</td>
                  <td>48</td>
                </tr>
                <tr>
                  <td>
                    Facebook Welcome Page
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        If you are running any seasonal campaign or special offer, we will create a customized landing
                        page aka welcome page on your Facebook business profile.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    Pinterest Account Creation <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create an account on Pinterest for your business also called as Pinterest Business
                        Account.
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Pinterest Optimization <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will optimize your Pinterest Business account by filling in all relevant details with your
                        business logo, description about your business and even verifying the profile.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Custom Pinboards <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will create custom Pinboards relevant to your industry on your Pinterest Business profile.
                      </span>
                    </span>
                  </td>
                  <td> 1</td>
                  <td> 2 </td>
                  <td> 4 </td>
                  <td> 6 </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Pin Images <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will pin images (or even video) relevant to your business on the custom created Pinboards.{' '}
                      </span>
                    </span>
                  </td>
                  <td> 4</td>
                  <td> 6 </td>
                  <td> 9 </td>
                  <td> 12 </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Follow Pinboards <i className="new-wrp" />
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will follow other relevant Pinboards to get updates from related sources with a change that
                        they’ll even follow yours.{' '}
                      </span>
                    </span>
                  </td>
                  <td> 12</td>
                  <td> 18</td>
                  <td> 24</td>
                  <td> 48 </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Facebook Ads Management*
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will follow other relevant Pinboards to get updates from related sources with a change that
                        they’ll even follow yours.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="cross-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <th>Reporting</th>
                  <td className />
                  <td className />
                  <td className />
                  <td className />
                </tr>
                <tr>
                  <td>
                    {' '}
                    Weekly SEO Status Reports
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will send you weekly reports which will include the work done in the last week along with the
                        current performance of the website.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Monthly SEO Performance Reports
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We will send you comprehensive monthly reports which will include the work done in the last
                        month along with the current performance of the website.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
                <tr>
                  <td>
                    {' '}
                    Customer Support (Email, Chat &amp; Telephone)
                    <span className="tooltipwrap">
                      <i>?</i>
                      <span>
                        {' '}
                        We have sales and service representatives that are available 24 hours Monday to Friday to answer
                        all your pre sales or support questions.{' '}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                  <td>
                    <span className="tik-mark" />
                  </td>
                </tr>
              </tbody>
            </table>
          </OpeningWrapper>
        </TableStyleCss>

        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SeoListing.js